/* eslint-disable react/prop-types */
/* eslint-disable no-undef */
/* eslint-disable import/prefer-default-export */
import React, {Fragment} from 'react';
import {View, Platform} from 'react-native';
import {AppConsumer} from '../../AppContext';
import {storePrefData, getPrefData, SIGNIN_OTP_VERIFIED, SIGNUP_OTP_VERIFIED, USER_LOCATION, IS_FOOTER_VISIBLE} from '../../storage/preferenceStorage';
import {getWidth, mobileCheck} from '../../utils/appUtils';
let originalSize = window.innerHeight + window.innerWidth;
const hocComponent = Component => {
  return class extends React.Component {
    static contextType = AppConsumer;

    constructor(props) {
      super(props);
      this.state = {
        measure: this.getMeasure(getWidth())
      };
    }

    // showToast = message => {};

    componentDidMount() {
      if (Platform.OS === 'web') {
        window.addEventListener('resize', this.getFooterStorageValue, {
          passive: true
        });
      }
    }

    async getFooterStorageValue() {
      let footervalue = await getPrefData(IS_FOOTER_VISIBLE);
      let div = window.document.getElementById('signedInFooter');
      let mobileandTabCheck = mobileCheck();
      if (window.innerHeight + window.innerWidth === originalSize) {
        //  storePrefData(IS_FOOTER_VISIBLE, 'true');
        if (div !== null) {
          div.style.display = 'block';
        }
      } else {
        if (footervalue === 'false' && mobileandTabCheck === true) {
          if (div !== null) {
            div.style.display = 'none';
          }
        }
      }
    }
    componentWillUnmount() {
      if (Platform.OS === 'web') {
        storePrefData(IS_FOOTER_VISIBLE, 'true');
      }
    }
    logMe = (tag, message) => {};

    handleLayout = ({nativeEvent}) => {
      const {width} = nativeEvent.layout;
      this.logMe('width>> ', width);
      const measure = this.getMeasure(width);
      this.setState(() => ({measure}));
    };

    getMeasure = width => {
      let measure = '';
      if (width < 360) {
        measure = 'LDPI';
      } else if (width < 480) {
        measure = 'MDPI';
      } else if (width < 640) {
        measure = 'HDPI';
      } else if (width < 768) {
        measure = 'XHDPI';
      } else if (width < 960) {
        measure = 'XXHDPI';
      } else if (width < 1024) {
        measure = 'XXXHDPI';
      } else if (width < 1440) {
        measure = 'LAPTOP';
      } else if (width < 2400) {
        measure = 'LAPTOP';
      }
      return measure;
    };

    componentWillMount() {
      this.checkSignUpRoute();
      this.checkSignInRoute();
    }

    checkSignUpRoute = async () => {
      const verified = await getPrefData(SIGNUP_OTP_VERIFIED);
      let countryName = await getPrefData(USER_LOCATION);
      if (countryName === 'US') {
        countryName = 'usa';
      } else if (countryName === 'UK') {
        countryName = 'uk';
      } else if (countryName === 'CAN') {
        countryName = 'canada';
      } else if (countryName === 'AUS') {
        countryName = 'australia';
      } else if (countryName === 'SIN') {
        countryName = 'singapore';
      } else if (countryName === 'UAE') {
        countryName = 'uae';
      } else {
        countryName = 'usa';
      }
      const {navigation} = this.props;

      if (
        Platform.OS === 'web' && 
        (!verified || verified === 'undefined' || verified === undefined)
      ) {
        const loginPageurl = Platform.OS === 'web' ? 'RegistrationLogin' : 'Registration';
        switch (window.location.pathname) {
          case '/personal-detail':
            navigation.navigate(`${loginPageurl}`);
            // code block
            break;
          case '/personal-detail-review':
            navigation.navigate(`${loginPageurl}`);
            // code block
            break;
          case '/personal-address':
            navigation.navigate(`${loginPageurl}`);
            break;
          case '/send-money-for-new-user':
            navigation.navigate(`${loginPageurl}`);
            break;
          case '/about-the-business':
            navigation.navigate(`${loginPageurl}`);
            break;
          case '/business-address':
            navigation.navigate(`${loginPageurl}`);
            break;
          case '/authorized-person':
            navigation.navigate(`${loginPageurl}`);
            break;
          case '/authorized-person-address':
            navigation.navigate(`${loginPageurl}`);
            break;
          case '/business-receipt':
            navigation.navigate(`${loginPageurl}`);
            break;
          default:
          // code block
        }
      }
    };

    checkSignInRoute = async () => {
      const verified = await getPrefData(SIGNIN_OTP_VERIFIED);
      let countryName = await getPrefData(USER_LOCATION);
      let currencyValue = '';
      if (countryName === 'US') {
        currencyValue = 'usd-to-inr';
        countryName = 'usa';
      } else if (countryName === 'UK') {
        currencyValue = 'gbp-to-inr';
        countryName = 'uk';
      } else if (countryName === 'CAN') {
        currencyValue = 'cad-to-inr';
        countryName = 'canada';
      } else if (countryName === 'AUS') {
        currencyValue = 'aud-to-inr';
        countryName = 'australia';
      } else if (countryName === 'SIN') {
        currencyValue = 'sgd-to-inr';
        countryName = 'singapore';
      } else if (countryName === 'UAE') {
        currencyValue = 'aed-to-inr';
        countryName = 'uae';
      } else {
        currencyValue = 'usd-to-inr';
        countryName = 'usa';
      }
      const {navigation} = this.props;

      if (
        Platform.OS === 'web' && 
        (!verified || verified === 'undefined' || verified === undefined)
      ) {
        const loginPageurl = Platform.OS === 'web' ? 'RegistrationLogin' : 'Registration';
        switch (window.location.pathname) {
          case `/${countryName}/my-recipients`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}//my-transaction`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/otpPopUp`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/confirmPassword`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case '/Landing':
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/reciept`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/my-rewards`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/add-recipients`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/view-breakup`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/add-account`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/send-money-business`:
            navigation.navigate(`${loginPageurl}`);
            break;
            case `/${countryName}/manage-my-account`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/SendMoney`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/ModelNotification`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/all-notifications`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/popup`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/profile`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case '/demo-dropdown':
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/refer-friend`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/subDollar-verification`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/upload-document`:
            navigation.navigate(`${loginPageurl}`);
            break;
          // case '/logout':
          //   navigation.navigate(`${loginPageurl}`);
          //   break;
          case `/${countryName}/changePassword`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case '/test':
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/forgotPassword`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/userIdLocked`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/resetPasswordLink`:
            // navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/forgotUserId`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/otpForgotPassword`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/expressDelivery`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/recipientRequest`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/expressDeliveryMobile`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/mobileViewExpressDelivery`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/pay-bill`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/pay-bill/add-landline`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/pay-bill/billing-status`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/pay-bill/landline-serviceProvider`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/pay-bill/add-insurance`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/pay-bill/policy_details`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/pay-bill/add-policy`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/pay-bill/manage-billers`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/pay-bill/bill-payments`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/pay-bill/electricity-bills`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/pay-bill/add-electricity`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/pay-bill/gas-agency`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/pay-bill/addGas-agency`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/select_account_details`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/new_add_account`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/account_details`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/sender_receipt`:
            navigation.navigate(`${loginPageurl}`);
            break;

          case `/${countryName}/transaction-details`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/currency-converter/${currencyValue.toString()}`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/confirmation`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/thankYouPage`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/pay-bill/prepaid-mobile-agency`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/pay-bill/add-prepaid-mobile-agency`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/pay-bill/postpaid-mobile-agency`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/pay-bill/add-postpaid-mobile-agency`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/powerProduct`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/netExpressProduct`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/highValueTransaction`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/add-recipientDetails`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/recipientBank-details`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/recipientInfo-individual`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/recipientInfo-business`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/recipient-address`:
            navigation.navigate(`${loginPageurl}`);
            break;
          case `/${countryName}/reverification`:
            navigation.navigate(`${loginPageurl}`);
            break;
          default:
          // code block
        }
      }
    };

    renderLoader = ShowLoader => {
      const {isLoading} = this.props;
      return ShowLoader({
        isLoading
      });
    };

    render() {
      const {measure} = this.state;
      const {ShowLoader} = this.context;
      return (
        <Fragment>
          <View onLayout={this.handleLayout} />
          <Component showToast={this.showToast} logMe={this.logMe} {...this.props} measure={measure} />
          {this.renderLoader(ShowLoader)}
        </Fragment>
      );
    }
  };
};

export {hocComponent};